import { dataFormat2, dataFormatMsc } from "../../../functions/dataFormat";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faCalendarCheck, faCalendarXmark } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from "@mui/material";

const WodaOdczytyRazemListaOkresow = props => {

    const { odczytyWm, wybranyZakres, handleZakres, handleRemove } = props;

    const listaOkresow = odczytyWm?.map( (d, i) => {

        const dataDo = d.okres_koniec ? dataFormat2(d.okres_koniec) : 'brak';

        const czyOpub = d?.opublikowany == 1 ? (
            <Tooltip
                title={`Opublikowany: ${dataFormatMsc(d?.miesiac)}`}
                placement="top"
            >
                <FontAwesomeIcon 
                    icon={faCalendarCheck} 
                    className="green"
                />
            </Tooltip>
        ) : (
            <Tooltip
                title="Nieopublikowany"
                placement="top"
            >
                <FontAwesomeIcon icon={faCalendarXmark} />
            </Tooltip>
        )

        return (
            <li 
                className= {wybranyZakres?.id == d?.id ? "ramka-woda pointer active" : "ramka-woda pointer"}  
                key={i}
                onClick={()=>handleZakres( d )}
            >
                <div className="okres">
                    <span>  
                        {`${dataFormat2(d.okres_poczatek)} - ${dataDo}`}
                    </span>
                    {czyOpub}
                    <FontAwesomeIcon
                        icon={faTrash} 
                        className="pointer"
                        onClick={()=>handleRemove(d?.id)}
                    />
                </div>
            </li>
        )
    })  

    return (
        <ul className="lista-okresy">
            {listaOkresow}
        </ul>
    )
}

export default WodaOdczytyRazemListaOkresow;